import { InferType, array, boolean, date, number, object, string } from "yup";

export const roadmapStageSchema = object({
  id: string().uuid().required(),
  title: string().required(),
  stageKey: string().required(),
  order: number().nullable().optional(),
  enabled: boolean().required(),
  createdAt: date().required(),
  updatedAt: date().required(),
  organizationId: string().uuid().nullable().optional(),
  deviceId: string().uuid().nullable().optional(),
});

export type RoadmapStage = InferType<typeof roadmapStageSchema>;

export const roadmapStagesSchema = array().of(roadmapStageSchema);

export type RoadmapStages = InferType<typeof roadmapStagesSchema>;
